import React, {Component, Fragment} from 'react';
import ReadyButton from 'components/ReadyButton';
import AudioPlayer from 'components/AudioPlayer';

import om_introNo from 'assets/sounds/no/intros/oneMinute-intro.mp3';
import om_introNn from 'assets/sounds/nn/intros/oneMinute-intro.mp3';
import strings from 'strings';
import {TYPES} from '../../constants/index';

class Intro extends Component {
	constructor(props) {
		super(props);

		switch (strings.getLanguage()) {
			case 'nn':
				this.om_intro = om_introNn;
				break;
			case 'no':
			default:
				this.om_intro = om_introNo;
				break;
		}
	}

	render() {
		const {ageGroup, testKeyType} = this.props;
		const isNormingTest =
			ageGroup >= 2 ||
			testKeyType === TYPES.ADULT_FOLLOWUP ||
			testKeyType === TYPES.YOUTH_FOLLOWUP;
		return (
			<Fragment>
				<p>
					<AudioPlayer autoplay inline src={this.om_intro} />
					{strings.om_intro}
				</p>
				{!isNormingTest && (
					<ReadyButton onReadyChange={this.props.setReady} />
				)}
			</Fragment>
		);
	}
}

export default Intro;
